import React, { useState, useEffect, useContext } from 'react';
import Div100vh from 'react-div-100vh';
import Button from '@/components/atoms/Button';
import DesktopExpand from '@/components/atoms/Icon/DesktopExpand';
import Text from '@/components/atoms/Text';
import { useLocation } from 'react-router-dom';
import { StateContext } from '@/state/store';
import { ShouldGoFullscreen, GoFullscreen } from '@/components/utils/DeviceUtils';
import './FullscreenOverlay.scss';
import { ApplicationContext } from '@/state/providers';

const STATE = {
    visible: 'visible',
    fadeText: 'fadeText',
    fadeBackground: 'fadeBackground',
    hidden: 'hidden',
};

let backgroundTimeout = null;
let hiddenTimeout = null;
let currentState = null;

const setVisibilityState = (visibilityState, setState, dispatch) => {
    if (currentState !== STATE.visible && visibilityState) {
        if (backgroundTimeout) {
            clearTimeout(backgroundTimeout);
            clearTimeout(hiddenTimeout);
        }

        setState(STATE.visible);
        dispatch({ type: 'SHOW_FULLSCREEN_OVERLAY' });
    } else if (currentState !== STATE.hidden) {
        backgroundTimeout = setTimeout(() => {
            setState(STATE.fadeBackground);
        }, 800);

        hiddenTimeout = setTimeout(() => {
            setState(STATE.hidden);
            dispatch({ type: 'HIDE_FULLSCREEN_OVERLAY' });
        }, 2666);
    }
};

const fullscreenChanged = (setState, dispatch) => {
    setVisibilityState(!document.fullscreenElement, setState, dispatch);
};

const init = (setState, location, dispatch) => {
    if (!ShouldGoFullscreen()) return;

    document.documentElement.addEventListener('fullscreenchange', () => {
        fullscreenChanged(setState, dispatch);
    });

    if (location.pathname !== '/' || (location.pathname === '/' && location.hash.slice(1) !== 'splash' && location.hash.slice(1) !== '')) {
        setVisibilityState(!document.fullscreenElement, setState, dispatch);
    }
};

const goFullscreen = (setState) => {
    setState(STATE.fadeText);

    setTimeout(() => {
        GoFullscreen();
    }, 1333);
};

export default () => {
    const [state, setState] = useState(STATE.hidden);
    const location = useLocation();

    const store = useContext(StateContext);
    const { dispatch } = store;
    const [{ device }] = useContext(ApplicationContext);
    const { body, cta } = device && device.android;

    useEffect(() => {
        init(setState, location, dispatch);
    }, []);

    const contentClass = state !== STATE.visible ? 'FullscreenOverlay__fadeOut' : '';
    const backgroundClass = state === STATE.fadeBackground || state === STATE.hidden ? 'FullscreenOverlay__fadeOut' : '';

    currentState = state;

    return (
        <>
            {ShouldGoFullscreen() && state !== STATE.hidden ? (
                <Div100vh className={['FullscreenOverlay', backgroundClass].join(' ')}>
                    <div className={['FullscreenOverlay__content', contentClass].join(' ')}>
                        <div className="FullscreenOverlay__icon">
                            <DesktopExpand speed={0.5} />
                        </div>
                        <div className="FullscreenOverlay__heading">
                            <Text className="transform-normal light">{body}</Text>
                        </div>
                        <Button
                            variant="primary-gold-light"
                            onClick={() => {
                                goFullscreen(setState);
                            }}
                            animate="in"
                        >
                            {cta && cta.fullscreen}
                        </Button>
                    </div>
                </Div100vh>
            ) : (
                ''
            )}
        </>
    );
};
